import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';
import { Label as LabelStyled } from '../Texts/Label/Label.styles';

const SelectButton = styled.ul`
  font-family: Ubuntu, serif;
  font-size: 16px;
  list-style-type: none;
  justify-content: space-between;
  flex-wrap: wrap;
  display: flex;
  text-align: center;
  ${({ fullWidth }) =>
    fullWidth === true &&
    css`
      display: grid;
      grid-template-columns: 100%;
    `}
`;

const TitleLabel = styled(LabelStyled)`
  display: block;
  margin: 10px 20px 20px;
  font-size: 11px;
  color: ${theme.oldColors['palette-neutral-n-2']};
`;

const Option = styled.li`
  text-align: center;

  ${({ type }) => getType(type)}
`;

const getType = (type) => {
  switch (type) {
    case 'basic':
      return css`
        flex-basis: 48%;
      `;
    case 'multiple':
      return css`
        flex-basis: 30%;
      `;
  }
};

const Input = styled.input`
  position: absolute;
  opacity: 0;
  ${({ disabled }) =>
    disabled === true
      ? css`
          &:checked {
            + {
              label {
                color: ${theme.oldColors['palette-input-disabled-text']};
                background-color: ${theme.oldColors[
                  'palette-buttons-primary-disabled'
                ]};
                border-color: ${theme.oldColors[
                  'palette-buttons-primary-disabled'
                ]};
              }
            }
          }
          cursor: not-allowed;
          pointer-events: none;
        `
      : css`
          &:checked {
            + {
              label {
                color: ${theme.oldColors['palette-background-cards-white']};
                background-color: ${theme.oldColors['palette-primary-p-1-p-1']};
                border-color: ${theme.oldColors['palette-primary-p-1-p-1']};
              }
            }
          }
        `}
`;

const OptionLabel = styled(LabelStyled)`
  width: 100%;
  padding: 5px;
  border: solid 1px ${theme.oldColors['border-row-table']};
  border-radius: 20px;
  ${({ disabled }) =>
    disabled === true
      ? css`
          color: ${theme.oldColors['palette-input-disabled-text']};
          cursor: not-allowed;
          pointer-events: none;
        `
      : `cursor: pointer;
         color: ${theme.colors['palette-neutral-n-2']};
        &:hover {
          background: ${theme.oldColors['border-row-table']};
        }`}
`;

export { SelectButton, TitleLabel, Option, Input, OptionLabel };
